import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  sicknessCount: number;
  otherCount: number;
}

export const JustifiedReasons: React.FC<Props> = ({
  sicknessCount,
  otherCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      <p className="flex items-center gap-1">
        <span className="text-body-13 md:text-caption-12 text-subtle-foreground">
          {t('overview.attendance.sickness')}
        </span>
        <span className="text-caption-13 md:text-body-14 text-muted-foreground">
          {sicknessCount}
        </span>
      </p>
      <p className="flex items-center gap-1">
        <span className="text-body-13 md:text-caption-12 text-subtle-foreground">
          {t('overview.attendance.other')}
        </span>
        <span className="text-caption-13 md:text-body-14 text-muted-foreground">
          {otherCount}
        </span>
      </p>
    </div>
  );
};
